import {
  type EntityType,
  serializeMention,
} from '@/lib/crm/record/memo/mentionUtils';

import {
  buildCreateInBuilderNavState,
  type BuilderModeNavState,
} from './buildBuilderModeNavState';

/**
 * `ahoy_automation_webhook` is not part of the closed `EntityType` union in
 * mentionUtils.ts (search-result entity types only). Widening to `string`
 * first, then narrowing, mirrors `entityMentionToken` in
 * buildChatAboutNavState.ts — the cast is safe because `serializeMention`
 * normalizes any string internally via `normalizeEntityType`.
 */
const WEBHOOK_ENTITY_TYPE: string = 'ahoy_automation_webhook';
const AUTOMATION_ENTITY_TYPE = 'ahoy_event_automation';

/**
 * Opens builder mode for `ahoy_event_automation`, grounded on the given
 * webhook via an initial prompt mention and entity-id hand-off.
 */
export function buildCreateWebhookAutomationNavState(
  orgId: number,
  webhookEntityId: string,
  displayName: string
): BuilderModeNavState {
  const mention = serializeMention(
    webhookEntityId,
    displayName,
    WEBHOOK_ENTITY_TYPE as EntityType
  );
  const initialPrompt = `I want to create an automation for the ${mention} inbound webhook. Read its recent received payloads and propose a script.`;
  return buildCreateInBuilderNavState(
    orgId,
    AUTOMATION_ENTITY_TYPE,
    initialPrompt,
    [webhookEntityId]
  );
}
